export const FAQ_2_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    question: "What is the duration of the course?",
    answer: "The course duration is typically 1 year.",
    priority: 1,
  },

  FAQ_FIELDS_CONFIG: [
    {
      fieldName: "layout_variant",
      label: "Layout Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Layout Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1 (Default)", value: "variant_1" },
        { label: "Variant 2 (Poppins Title)", value: "variant_2" },
      ],
    },
    {
      fieldName: "title_1",
      label: "Title 1 (hidden for variant 2)",
      value: "Frequently Asked",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title 1",
      required: false,
      defaultValue: "Frequently Asked",
    },
    {
      fieldName: "title_1_color",
      label: "Title 1 Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title 1 color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "title_2",
      label: "Title 2",
      value: "Questions",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title 2",
      required: false,
      defaultValue: "Questions",
    },
    {
      fieldName: "title_2_gradient_start_color",
      label: "Title 2 Gradient Start Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter gradient start color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_2_gradient_end_color",
      label: "Title 2 Gradient End Color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter gradient end color",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "section_background_color",
      label: "Section Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter section background color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Background Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 1",
      required: false,
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "#000000A8",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 2",
      required: false,
      defaultValue: "#000000A8",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "#000000A8",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 3",
      required: false,
      defaultValue: "#000000A8",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "#5345C3",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 4",
      required: false,
      defaultValue: "#5345C3",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Background Color",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "top_arrow_icon",
      label: "Top Arrow Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload top arrow icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "top_arrow_icon_alt",
      label: "Top Arrow Icon Alt Text",
      value: "Expand",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for top arrow icon",
      required: false,
      defaultValue: "Expand",
    },
    {
      fieldName: "bottom_arrow_icon",
      label: "Bottom Arrow Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload bottom arrow icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "bottom_arrow_icon_alt",
      label: "Bottom Arrow Icon Alt Text",
      value: "Collapse",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for bottom arrow icon",
      required: false,
      defaultValue: "Collapse",
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Scroll reveal on section content",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "status",
      label: "FAQ Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable FAQ Section",
      required: false,
      defaultValue: false,
    },
  ],

  // Category fields configuration for Form_3
  CATEGORY_FIELDS_CONFIG: [
    {
      fieldName: "name",
      label: "Category Name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter category name (e.g., Courses, Fee, Curriculum)",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "text_color",
      label: "Category Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter category text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "background_color",
      label: "Category Background Color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter category background color (e.g., #ffffff)",
      required: false,
      defaultValue: "#ffffff",
    },
    {
      fieldName: "active_text_color",
      label: "Active Category Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter active category text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "active_background_color",
      label: "Active Category Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter active category background color",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "order_index",
      label: "Display Order",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter display order (1, 2, 3...)",
      required: true,
      defaultValue: 1,
    },
    {
      fieldName: "status",
      label: "Category Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable category",
      defaultValue: true,
    },
  ],

  // FAQ table fields configuration for Form_3
  FAQ_TABLE_FIELDS_CONFIG: [
    {
      header: "Question",
      fieldName: "question",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter question",
      required: true,
    },
    {
      header: "Question Text Color",
      fieldName: "question_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter question text color (e.g., #000000)",
      required: false,
    },
    {
      header: "Answer",
      fieldName: "answer",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter answer",
      required: true,
    },
    {
      header: "Answer Text Color",
      fieldName: "answer_text_color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter answer text color (e.g., #666666)",
      required: false,
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter priority (1, 2, 3...)",
      required: true,
    },
    {
      header: "Top Arrow Icon",
      fieldName: "top_arrow_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload top arrow icon",
      required: false,
    },
    {
      header: "Top Arrow Icon Alt Text",
      fieldName: "top_arrow_icon_alt",
      value: "Expand",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for top arrow icon",
      required: false,
    },
    {
      header: "Bottom Arrow Icon",
      fieldName: "bottom_arrow_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload bottom arrow icon",
      required: false,
    },
    {
      header: "Bottom Arrow Icon Alt Text",
      fieldName: "bottom_arrow_icon_alt",
      value: "Collapse",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for bottom arrow icon",
      required: false,
    },
  ],
};
